const TEMP_LOCAL_STORAGE_KEY_NAME = '_ctiTempKeyName'
const TEMP_LOCAL_STORAGE_VALUE_NAME = '_ctiTempValueName'
const ENABLE_TEMP_COPY_KEY_NAME = '_ctiTempCopyOn'

const ENABLE_INIT_SYNC_KEY_NAME = '_ctiTempInitOn'

const TEMP_COPY_MODE = 'ADD'
const TEMP_DELETE_MODE = 'DELETE'

// make this dynamic, so we don't need to add keys we need to synch
const KEYS_TO_SYNC_ON_LOAD = ['apiToken', 'DOCUMENT_TO_OPEN', 'ESC_PROFILE']

let STORAGE_STATE = null

function init() {
  window.addEventListener(
    'storage',
    function (event) {
      if (STORAGE_STATE > 0) {
        // if storage is triggered by outside setItem call, allow it to run once.
        STORAGE_STATE = 0
      } else if (STORAGE_STATE === 0) {
        // if storage is triggered within this event listener (only in IE 11), then suppress it.
        STORAGE_STATE = null
        return
      }

      // WRITE OR DELETE MODE
      var enableTempMode = window.localStorage.getItem(
        ENABLE_TEMP_COPY_KEY_NAME
      )
      if (enableTempMode === TEMP_COPY_MODE && event.newValue) {
        let tempKey = window.localStorage.getItem(TEMP_LOCAL_STORAGE_KEY_NAME)
        let tempValue = window.localStorage.getItem(
          TEMP_LOCAL_STORAGE_VALUE_NAME
        )

        window.sessionStorage.setItem(tempKey, tempValue)
      } else if (enableTempMode === TEMP_DELETE_MODE) {
        window.sessionStorage.removeItem(
          window.localStorage.getItem(TEMP_LOCAL_STORAGE_KEY_NAME)
        )
      }

      // INIT SYNCH MODE
      var enableInitMode = window.localStorage.getItem(
        ENABLE_INIT_SYNC_KEY_NAME
      )
      if (enableInitMode) {
        for (var i = 0; i < KEYS_TO_SYNC_ON_LOAD.length; i++) {
          let synchKey = KEYS_TO_SYNC_ON_LOAD[i]
          let synchValue = getItem(synchKey)
          if (synchValue) {
            setItem(synchKey, synchValue, true)
          }
        }
        window.localStorage.removeItem(ENABLE_INIT_SYNC_KEY_NAME)
      }
    },
    false
  )

  // asynch tab fun
  setTimeout(function () {
    window.localStorage.setItem(ENABLE_INIT_SYNC_KEY_NAME, 'yes')
  }, 0)
}

function setItem(key, value, isInternal) {
  STORAGE_STATE = !isInternal ? 1 : null // for IE 11 only: if this is called outside this class, set a value.
  window.sessionStorage.setItem(key, value)

  // by setting these, the other windows will listen to the storage event and grab the values
  window.localStorage.setItem(TEMP_LOCAL_STORAGE_KEY_NAME, key)
  window.localStorage.setItem(TEMP_LOCAL_STORAGE_VALUE_NAME, value)
  window.localStorage.setItem(ENABLE_TEMP_COPY_KEY_NAME, TEMP_COPY_MODE)

  removeTempItemsFromLocalStorage()
}

function getItem(key) {
  return window.sessionStorage.getItem(key)
}

function removeItem(key) {
  window.sessionStorage.removeItem(key)

  window.localStorage.setItem(ENABLE_TEMP_COPY_KEY_NAME, TEMP_DELETE_MODE)

  // by setting these, the other windows will listen to the storage event and grab the values
  window.localStorage.setItem(TEMP_LOCAL_STORAGE_KEY_NAME, key)

  removeTempItemsFromLocalStorage()
}

function removeTempItemsFromLocalStorage() {
  // need to make this asynch since we have to deal with multi threads from different browser tabs
  setTimeout(function () {
    window.localStorage.removeItem(TEMP_LOCAL_STORAGE_KEY_NAME)
    window.localStorage.removeItem(TEMP_LOCAL_STORAGE_VALUE_NAME)

    // remove this last
    window.localStorage.removeItem(ENABLE_TEMP_COPY_KEY_NAME)
  }, 0)
}

export { init, getItem, setItem, removeItem }
